import React, { Component } from 'react';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";


class ModalPendencias extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }
    render() {

        return (
            <Modal isOpen={this.props.isOpen} toggle={this.props.toggle}>
                <ModalHeader toggle={this.props.toggle}>Campos obrigatórios</ModalHeader>
                <ModalBody>
                    <p>Por favor, preencha o(s) seguinte(s) campo(s) obrigatório(s):</p>
                    <ul>
                        {this.props.pendencias && this.props.pendencias.map((item, index) => {
                            return <li key={`campo-${index}`}>{item.campo}</li>
                        })}
                    </ul>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={this.props.toggle}>ok</Button>
                </ModalFooter>
            </Modal>
        );
    }
}

export default ModalPendencias;